import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

// Create course
export const saveDriverMarkingAssessment = data => post(url.SAVE_DRIVER_MARKING_ASSESSMENT, data);
export const getAllDriverMarkingAssessmentOfBatch = id => get(url.GET_ALL_DRIVER_MARKING_ASSESSMENT_OF_BATCH + id);